import {
  Activity,
  AlarmClock,
  CalendarDays,
  ChartColumnBig,
  CheckSquare,
  CircleCheckBig,
  Handshake,
  Landmark,
  MonitorPlay,
  PhoneCall,
  PhoneForwarded,
  StickyNote,
  TimerReset,
  Wallet,
  type LucideIcon,
} from 'lucide-react'
import type { ComponentType } from 'react'
import type { WidgetBodyProps, WidgetType } from '../types'
import { CalendarWidget } from './CalendarWidget'
import { FinanceSummaryWidget, PaymentsWidget } from './FinanceWidgets'
import { KpiActiveDemos, KpiOpenTasks, KpiOverdueFollowups, KpiOverdueTasks } from './KpiWidgets'
import { NotesWidget } from './NotesWidget'
import { EndingDemosWidget, FollowupsWidget, InstallHealthWidget, MeetingsWidget } from './SalesWidgets'
import { MyTasksWidget, ProjectsWidget } from './WorkWidgets'

type WidgetDef = { icon: LucideIcon; Body: ComponentType<WidgetBodyProps> }

export const WIDGETS: Record<WidgetType, WidgetDef> = {
  kpiOpenTasks: { icon: CheckSquare, Body: KpiOpenTasks },
  kpiOverdueTasks: { icon: AlarmClock, Body: KpiOverdueTasks },
  kpiOverdueFollowups: { icon: PhoneCall, Body: KpiOverdueFollowups },
  kpiActiveDemos: { icon: MonitorPlay, Body: KpiActiveDemos },
  myTasks: { icon: CircleCheckBig, Body: MyTasksWidget },
  payments: { icon: Wallet, Body: PaymentsWidget },
  notes: { icon: StickyNote, Body: NotesWidget },
  calendar: { icon: CalendarDays, Body: CalendarWidget },
  projects: { icon: ChartColumnBig, Body: ProjectsWidget },
  meetings: { icon: Handshake, Body: MeetingsWidget },
  followups: { icon: PhoneForwarded, Body: FollowupsWidget },
  endingDemos: { icon: TimerReset, Body: EndingDemosWidget },
  installHealth: { icon: Activity, Body: InstallHealthWidget },
  financeSummary: { icon: Landmark, Body: FinanceSummaryWidget },
}